import React, { useState, useEffect} from "react";

import ComposeView from "../../index";
import Slider from "src/components/slider";

import styles from "./dialog.module.scss";
import { Asset } from "src/types/assets";
import { Collection } from "src/types/collections";

import _ from "lodash";
interface ComposeDialogProps {
  show: boolean;
  dialog: boolean;
  sourceType?: string;
  initialContent: any;
  emailBody?: string;
  onFinish?: () => void;
  onClose: () => void;
  recipientType?: string;
}

const ComposeDialog: React.FC<ComposeDialogProps> = ({
  show,
  dialog,
  initialContent,
  emailBody,
  onFinish,
  sourceType,
  onClose,
  recipientType
}) => {
  // Layout styles configuration for the compose view
  const [layoutWidth, setLayoutWidth] = useState("65vw");

  const [content, setContent] = useState(initialContent);

  useEffect(() => {
    if(show) {
      const filteredInitialContent = initialContent.map((content) => {
        if (content.entityType === "collection" || content.entityType === "deal_room") {
          return {
        ...content,
        assets: _.filter(content.assets, asset => asset.asset?.settings?.share),
          };
        }
        return content;
      });
      setContent(filteredInitialContent);
    }
  }, [show]);

  // Depending on the panel the layout will be adjusted fot the compose view
  const handleLayoutChange = (changed: boolean) => {
    var width = layoutWidth;

    if (changed) {
      width = `calc(${layoutWidth} + 420px)`;
    } else {
      width = "65vw";
    }
    setLayoutWidth(width);
  };

  return (
    <Slider.Dialog width={layoutWidth} show={show} onClose={onClose}>
      <Slider.Body className={styles.composeDialog}>
        <ComposeView
          recipientType={recipientType}
          sourceType={sourceType}
          dialog={true}
          initialContent={content}
          emailBody={emailBody}
          onFinish={onFinish}
          onClose={onClose}
          onLayoutChange={(changed) => handleLayoutChange(changed)}
        />
      </Slider.Body>
    </Slider.Dialog>
  );
};

export default ComposeDialog;
